/* Common CODE */

export const MODE = {
    VIEW: 'view',
    EDIT: 'edit',
    REGISTER: 'register',
}

export const AUTHORITIES = {
    ADMIN: 'ROLE_ADMIN',
    USER: 'ROLE_USER',
    SYSTEM: 'ROLE_SYSTEM',
}

export const USER_ROLE = {
    ROLE_ADMIN: '관리자',
    ROLE_USER: '일반사용자',
    ROLE_SYSTEM: '시스템 관리자',
}

export const REACT_APP_API_URL = process.env.REACT_APP_API_URL

export const ICPKIT_FOLDER = [
    { value: '1', name: '소스코드' },
    { value: '2', name: '가이드문서' },
    { value: '3', name: '설치파일' },
]

/**
 * 카드 이미지 로드 Fallback용 이미지 큰 것
 */
export const IMG_NOCARD_B = '/assets/images/temp/img-nocard-b.svg'
/**
 * 카드 이미지 로드 Fallback용 이미지 작은 것
 */
export const IMG_NOCARD_S = '/assets/images/temp/img-nocard-s.svg'
